import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import type { ArticleListRequest, NoticeListRequest } from "../dto/request/community.request";
import { communityArticleComment, communityArticleDetail, communityArticleList, noticeDetail, noticeList } from "../v1/community.service";

export const useCommunityArticleList = (form: ArticleListRequest) => infiniteQueryOptions({
    queryKey: ["community-article-list", form],
    queryFn: ({ pageParam }) => communityArticleList({...form, page: pageParam, pageSize: 10}),
    retry: 1,
    initialPageParam: 1,
    getNextPageParam: (lastPage, pages) => {
      const fetchedItemsCount = lastPage.data.articleList.length || 0;
      if (fetchedItemsCount < 10) {
        return undefined;
      }

      return pages.length + 1;
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })

export const useCommnuityArticleDetail = (id: string | number) => queryOptions({
    queryKey: ["community-article-detail", id],
    queryFn: () => communityArticleDetail(id),
    retry: 1
})

export const useCommunityArticleComment = (id: string | number) => infiniteQueryOptions({
  queryKey: ["community-article-comment", id],
  queryFn: ({ pageParam }) => communityArticleComment(id, { commentPage: pageParam, commentPageSize: 10 }),
  retry: 1,
  initialPageParam: 1,
  getNextPageParam: (lastPage, pages) => {
    const fetchedItemsCount = lastPage.data.commentList.length || 0;
    if (fetchedItemsCount < 10) {
      return undefined;
    }

    return pages.length + 1;
  },
  refetchOnMount: false,
  // refetchOnMount: "always",    
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
})

/** 공지사항 목록 */
export const useNoticeList = (form?: NoticeListRequest) =>
  queryOptions({
    queryKey: ["notice-list", form],
    queryFn: () => noticeList(form),
    retry: 1,
  });

/** 공지사항 상세 */
export const useNoticeDetail = (id: string | number) =>
  queryOptions({
    queryKey: ["notice-detail", id],
    queryFn: () => noticeDetail(id),
    retry: 1,
  });